import type { TFunction } from 'i18next';

export { getAssessmentContentLocale } from '@/utils/locale';

export interface InferredScoreFields {
  is_inferred?: boolean;
  score?: number;
  question_index?: number;
  score_explanation?: string;
  evidence?: string;
}

/** Localize inferred-score copy from metadata; LLM evidence is returned as-is. */
export function resolveInferredExplanation(
  score: InferredScoreFields,
  t: TFunction<'candidates'>,
): string {
  if (score.is_inferred !== true) {
    return score.evidence ?? score.score_explanation ?? '';
  }

  if (score.question_index === -1) {
    return t('meta_cv.inferred.skill_missing');
  }
  if (score.score === 1) {
    return t('meta_cv.inferred.silent');
  }
  return t('meta_cv.inferred.benefit_of_doubt');
}
